<template>
    <sidebar-menu :items="items" has-icon @update:expanded="$emit('update:expanded', $event)" />
</template>

<script>
import SidebarMenu from '@/components/sidebar/SidebarMenu.vue';

export default {
    name: 'InboxSidebar',

    components: { SidebarMenu },

    emits: ['update:expanded'],

    computed: {
        items() {
            return [
                {
                    type: 'item',
                    title: 'Announcements',
                    route: {
                        name: 'inbox-announcements',
                    },
                    icon: 'pi pi-megaphone',
                },
                {
                    type: 'item',
                    title: 'Discussions',
                    route: {
                        name: 'inbox-discussions',
                    },
                    icon: 'pi pi-comments',
                },
            ];
        },
    },

    created() {
        if (this.$hasFeature('MESSAGES')) {
            this.items.push({
                type: 'item',
                title: 'Messages',
                route: {
                    name: 'inbox-messages',
                },
                icon: 'pi pi-envelope',
            });
        }
    },
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.custom-size {
    height: 100%;
    width: 300px;
    background: var(--p-content-background);
}
.minimized-container {
    background: #eff7fa;

    .sidebar-background {
        background: #eff7fa;
    }
}
</style>
